import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import check_german_exitence from "./GermanCell";
import RomanizationFormatter from "../romanization-formater";
import GermanCell from "./GermanCell";
import { defaultFontSize } from "../../common/style-consts";

interface RowCountTwoTableProps {
  data: any;
}

const RowCountTwoTable: React.FC<RowCountTwoTableProps> = ({ data }) => {
    const processGermanItems = (item: any) => {
      const germanWords = item.german.split('\n').map((word: string) => word.trim());
      if (germanWords.length > 1) {
        // If there are multiple German words, duplicate the item
        const duplicatedItems = germanWords.map((word: string, index: number) => ({
          ...item,
          id: item.id * 1000 + index, // Adjust the ID to make it unique
          german: word
        }));
  
        // Return the duplicated items
        return duplicatedItems;
      }
  
      // If there is only one German word, return the original item
      return [item];
  };
  

    // Process the data to include duplicated items
    const processedData = data.flatMap(processGermanItems);

      // Function to copy URL to clipboard
  const handleRowClick = () => {
    const currentUrl = window.location.href; // Get the current URL
    navigator.clipboard.writeText(currentUrl).then(() => {
      alert("URL copied to clipboard!");
    }).catch((err) => {
      console.error("Failed to copy: ", err);
    });
  };

  return (
    <>
      <Row style={{ width: "95%", justifyContent: "center" }}>
        <Col className="gy-3">
          <Table
            responsive
            striped
            bordered
            hover
            variant="dark"
            style={{ fontSize:  defaultFontSize }}
          >
            <thead>
              <tr onClick={handleRowClick}>
                <th>Deutsch</th>
                <th style={{ direction: "rtl" }}>Arabisch</th>
              </tr>
            </thead>
            <tbody>
              {processedData.map((item: any) => (
                <tr key={item.id} onClick={handleRowClick}>
                  <td>
                    <GermanCell item={item} />
                  </td>
                  <td style={{ direction: "rtl" }}>
                    {item.arabic + "-"}
                    <RomanizationFormatter
                      inputString={item.arabic_romanization}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
};

export default RowCountTwoTable;
